/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { DialogService } from 'nebula-ui-kit';
import { TranslationService } from '@nebula-shared/data-access';
import { map, Observable } from 'rxjs';
import { SelectDialogComponent } from '../../../select-dialog/select-dialog.component';
import { StateService } from './departamentos.service';
import { StatesModal } from '../../domain/departamentos-modal.model';

@Injectable({
  providedIn: 'root',
})
export class StateModalService {
  readonly dialogService = inject(DialogService);
  private readonly translation = inject(TranslationService);

  /** Textos del selector en el idioma de la aplicacion. */
  private t(clave: string): string {
    return this.translation.translate(clave);
  }

  readonly paisesService = inject(StateService);
  /**
   * @deprecated Abre el selector viejo (SelectDialogComponent). Usa
   * {@link BuscadorMaestroService.abrir} de `@nebula-shared/ui`, la ventana de seleccion del
   * Manual 3.0 (tipo A, selector de catalogo:
   * http://10.120.0.2:8552/propuesto/dist/components/modales.html), con el page-response que
   * este selector ya consulta (`StateService.getAllState`). Se retira cuando no quede quien lo llame.
   */
  openSelector(title: string, pais: string, currentValue?: string): Observable<StatesModal | null> {
    const columns = [
      { key: 'codigo', label: this.t('COLUMNS.CODE'), sortable: true, width: '30%' },
      { key: 'nombre', label: this.t('COLUMNS.NAME'), sortable: true, width: '70%' },
    ];
    const loadDataFn = async (params: any): Promise<{ data: StatesModal[]; total: number }> => {
      const page = params.page - 1;
      const size = params.limit || 10;
      const searchTerm = params.search || '';
      const sortColumn = params.sortColumn || '';
      const sortDirection = params.sortDirection || '';

      const response = await this.paisesService
        .getAllState(page, size, pais, searchTerm, sortColumn, sortDirection)
        .pipe(
          map((response: any) => {
            return {
              data: response.content || [],
              total: response.totalElements || 0,
            };
          }),
        )
        .toPromise();

      return response || { data: [], total: 0 };
    };

    const dialogRef = this.dialogService.open(SelectDialogComponent, {
      data: {
        title: title,
        columns: columns,
        multiSelect: false,
        searchPlaceholder: this.t('MODAL.SEARCH_BY_CODE_OR_NAME'),
        loadDataFn: loadDataFn,
        itemIdKey: 'id',
        displayKey: 'codigo',
        selectedItems: currentValue ? [{ codigo: currentValue, nombre: currentValue }] : [],
        pageSize: 10,
        pageSizeOptions: [10, 25, 50, 100],
      },
      size: 'lg',
      width: '700px',
    });

    return dialogRef
      .afterClosed()
      .pipe(
        map((selected: StatesModal[]) => (selected && selected.length > 0 ? selected[0] : null)),
      );
  }
}
